/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, {
  useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import {
  Grid,
  Typography,
  Button,
} from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import formStyle, { WrapContainer } from './formStyle';
import { Rules } from '../../../helpers/RHFRules';
import {
  Loading,
  Toaster,
  CustomInput,
} from '../../../components';
import {
  useRegisterScreen,
  useUpdateScreen,
} from '../../../services';
import { ActionPopUp } from '../../../Layouts';

const ActionForm = ({
  open,
  data,
  title,
  defaultValues,
  setDefaultValues,
  onClose,
  getScreens,
}) => {
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [canEdit, setCanEdit] = useState(false);

  const {
    registerScreen,
    loading,
    error: errorResponse,
  } = useRegisterScreen();

  const {
    updateScreen,
    loading: loadingUpdate,
    error: errorUpdate,
  } = useUpdateScreen();

  const classes = formStyle();
  const providerRef = React.useRef();

  const {
    handleSubmit, control, errors, reset, clearErrors,
  } = useForm({ defaultValues });

  const resetFields = () => {
    setCanEdit(false);

    setDefaultValues({
      id: '',
      screenName: '',
    });
  };

  const enableEdition = () => {
    setCanEdit((prev) => !prev);
  };

  const handleOnclose = () => {
    resetFields();
    onClose();
  };

  const handleSave = async (dataParam) => {
    clearErrors();
    const body = {
      id: dataParam.id,
      screenName: dataParam.screenName,
    };
    let message;
    let response;
    if (data) {
      body.id = data.id;
      response = await updateScreen({ data: body });
      message = 'Se ha editado la sección exitosamente';
    } else {
      response = await registerScreen({ data: body });
      message = 'Se ha cargado la sección exitosamente';
    }
    if (response && [200, 201].includes(response.status)) {
      getScreens();
      providerRef.current.enqueueSnackbar(message, {
        variant: 'success',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
      resetFields();
      setCanEdit(false);
      onClose();
    }
  };

  useEffect(() => {
    if (errorResponse) {
      const message = `Ocurrio un error al crear el registro. Intentelo nuevamente. ${errorResponse.message || ''}`;
      providerRef.current.enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
    }

    if (errorUpdate) {
      const message = `Ocurrio un error al actualizar el registro. Intentelo nuevamente. ${errorUpdate.message || ''}`;
      providerRef.current.enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
    }
  }, [errorResponse, errorUpdate]);

  useEffect(() => {
    reset(defaultValues);
  }, [open]);

  useEffect(() => {
    if (data !== null) setCanEdit(true);
  }, [data]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setAlert({ status: true, type: 'warning', message: 'campos obligatorios faltantes' });
    }
  }, [errors]);

  return (
    <SnackbarProvider ref={providerRef}>
      <ActionPopUp
        open={open}
        data={data}
        title={title}
        onClose={handleOnclose}
        onSave={handleSubmit(handleSave)}
        enabledControls
      >
        <>
          {data !== null && <Button variant="outlined" color="primary" onClick={enableEdition}>Habilitar edición</Button>}
          <WrapContainer marginTop={15}>&nbsp;</WrapContainer>
          <form noValidate autoComplete="off" className={classes.formContainer}>
            <Grid
              container
              justifyContent="space-evenly"
              alignItems="stretch"
              spacing={2}
            >
              <Grid item xs={12}>
                <Typography variant="h6">
                  Registrar sección back-office:
                </Typography>
              </Grid>
              {/* @#promocion */}
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CustomInput
                  label="Nombre sección *"
                  name="screenName"
                  control={control}
                  rule={Rules.required}
                  error={errors}
                  inputProps={{
                    maxLength: 48,
                  }}
                  disabled={canEdit}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={8} />
            </Grid>
            <WrapContainer marginTop={15}>&nbsp;</WrapContainer>
          </form>
        </>
        {(loading || loadingUpdate) && <Loading />}
        <Toaster
          show={alert.status}
          type={alert.type}
          text={alert.message}
          onClose={() => setAlert({ ...alert, status: false })}
        />
      </ActionPopUp>
    </SnackbarProvider>
  );
};

ActionForm.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActionForm;
